// TODO: DASHBOARD
export const KEY_SPONSORED_COMMUNITY_DASHBOARD_INFO =
  "KEY_SPONSORED_COMMUNITY_DASHBOARD_INFO";

// TODO: ANALYTICS
export const KEY_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_VIEW =
  "KEY_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_VIEW";
export const KEY_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_REACH =
  "KEY_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_REACH";
export const KEY_SPONSORED_COMMUNITY_ANALYTICS_LOCATION_INFO =
  "KEY_SPONSORED_COMMUNITY_ANALYTICS_LOCATION_INFO";
export const KEY_SPONSORED_COMMUNITY_ANALYTICS_ZONE_INFO =
  "KEY_SPONSORED_COMMUNITY_ANALYTICS_ZONE_INFO";
export const KEY_SPONSORED_COMMUNITY_ANALYTICS_DEVICE_INFO =
  "KEY_SPONSORED_COMMUNITY_ANALYTICS_DEVICE_INFO";
export const KEY_SPONSORED_COMMUNITY_ANALYTICS_MOBILE_DEVICE_INFO =
  "KEY_SPONSORED_COMMUNITY_ANALYTICS_MOBILE_DEVICE_INFO";
export const KEY_SPONSORED_COMMUNITY_ANALYTICS_BROWSER_INFO =
  "KEY_SPONSORED_COMMUNITY_ANALYTICS_BROWSER_INFO";
export const KEY_SPONSORED_COMMUNITY_ANALYTICS_SPECIALITY_INFO =
  "KEY_SPONSORED_COMMUNITY_ANALYTICS_SPECIALITY_INFO";
export const KEY_SPONSORED_COMMUNITY_ANALYTICS_READS_BY_DURATION_INFO =
  "KEY_SPONSORED_COMMUNITY_ANALYTICS_READS_BY_DURATION_INFO";
export const KEY_SPONSORED_COMMUNITY_CONTENT_VIEWS_READS =
  "KEY_SPONSORED_COMMUNITY_CONTENT_VIEWS_READS";
export const KEY_SPONSORED_COMMUNITY_REACH = "KEY_SPONSORED_COMMUNITY_REACH";

// TODO: CONTENTS
export const KEY_SPONSORED_COMMUNITY_CONTENT_INFO =
  "KEY_SPONSORED_COMMUNITY_CONTENT_INFO";
export const KEY_SPONSORED_COMMUNITY_SUBSCRIBERS_COUNT =
  "KEY_SPONSORED_COMMUNITY_SUBSCRIBERS_COUNT";

//   TODO: COMMENTS
export const KEY_SPONSORED_COMMUNITY_COMMENTS_INFO =
  "KEY_SPONSORED_COMMUNITY_COMMENTS_INFO";
